import React from 'react';
import { withRouter } from 'react-router-dom';
//import PropTypes from 'prop-types';
import { Layout, Drawer } from 'antd';
import SideMenu from '../../components/Layout/SideMenu';
import { GlobalConfigConsumer } from '../../components/Config/GlobalConfigContext';
import { loadState, saveState } from '../../utilities/localStorage';
import { GlobalConfigContext } from '../Config/GlobalConfigContext';
const defaultProps = {
	menu_position:'horizontal'
  };
const { Sider } = Layout;

class Navigation extends React.PureComponent {
    static contextType = GlobalConfigContext;
	constructor(props) {
		super(props);
		const settings = loadState();
		this.state = {
			openDrawer: false,
			sider_collapsed: settings?settings.sider_collapsed:false,
            sider_mode: (settings && settings.sider_mode)?settings.sider_mode:'inline',
		};
	}
	toggleDrawer = () => {
        this.setState((prevState) => {
            return {
                openDrawer: !prevState.openDrawer
            };
        });
	}
    closeDrawer = () => {
		this.setState({
			openDrawer: false,
		});
	}
	onCollapseSider = (sider_collapsed) => {
        //console.log(collapsed);
        this.setState({
            sider_collapsed,
            sider_mode: sider_collapsed ? 'vertical' : 'inline',
        });
        saveState({ 
            sider_collapsed,
            sider_mode: sider_collapsed ? 'vertical' : 'inline'
        });
    }
    render() {

		const { openDrawer, sider_collapsed } = this.state;
		const { displayHamburger, menu_position } = this.props;
		const { breakpoint } = this.context;

        return (
            <GlobalConfigConsumer>
      			{({ sider_position, theme, isMobile, isTablet }) => {
      	
				return (
                    (sider_position === 'top'|| isMobile || isTablet)
						? <React.Fragment>
							{ displayHamburger && <div className={`drawer-handle-btn ${openDrawer?'drawer-open':''}`} onClick={this.toggleDrawer}>
								<i className="drawer-handle-btn-icon" />
							</div> }
							<Drawer
								visible={openDrawer}
								onClose={this.closeDrawer}
								handler={false}
								width={300}
								closable={false}
								placement="left"
								mask={true}
								zIndex={997}
								wrapperClassName="drawer-wrapper"
								bodyStyle={{ marginTop:64 }}
								//getContainer={() => document.getElementById(`layout-container`)}
							>
								<SideMenu menu={this.props.menu} path={this.props.location.pathname} collapsed={sider_collapsed} mode='inline' drawer={true} closeDrawer={this.closeDrawer} history={this.props.history}/>
							</Drawer>
						</React.Fragment>
						:
						(menu_position === 'horizontal')
						?
						<SideMenu menu={this.props.menu} path={this.props.location.pathname} collapsed={sider_collapsed} triger='click' mode='horizontal' drawer={true} history={this.props.history}/>
						:	
						<Sider 
							theme={theme}
							width={['xxl','xxxl'].includes(breakpoint) ? 220 : 220}
							//style={{ paddingTop: 20, textAlign:'left' }}
							className="main-sider"
							collapsible
							collapsed={sider_collapsed}
							onCollapse={this.onCollapseSider}
						>
						<SideMenu menu={this.props.menu} path={this.props.location.pathname} collapsed={sider_collapsed} mode='inline' drawer={true} history={this.props.history}/>
					</Sider>
                )
            }}
            </GlobalConfigConsumer>
        )
    }
}
Navigation.defaultProps = defaultProps;
export default withRouter(Navigation);

//displayHamburger